// @flow
/* eslint-disable no-unused-vars */
import * as wjcCore from 'wijmo/wijmo';
import moment from 'moment';
import { createColumnOrRowFormatter, getDateFormat } from '../../../utils';
import type { FormatterArgs } from '../../../types';

export const HOLD_ACCEPTED_VALUES = ['MO', 'IN', 'BH'];

const holdFormatter = (args?: FormatterArgs) =>
  createColumnOrRowFormatter({
    columnName: 'Hold',
    formatStyle: 'row', // can be wheter 'row' or 'cell'.
    formatter: ({ elem, dataItem }) => {
      const item = dataItem;

      const today = moment().format(getDateFormat('clientShort'));
      const tomorrow = moment().add(1, 'days').format(getDateFormat('clientShort'));

      const fieldDate = moment(item.ExpDate).format(getDateFormat('clientShort'));

      let color = '';

      if (HOLD_ACCEPTED_VALUES.includes(item.Hold)) {
        if (fieldDate === today) {
          color = 'red';
        }
        if (fieldDate === tomorrow) {
          color = 'yellow';
        }
      }

      wjcCore.addClass(elem.cell, color);
    },
  });

export default holdFormatter;
